import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

export const MapsPopup = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-3 sm:p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full sm:w-[95%] md:w-[90%] lg:w-[85%] xl:w-[80%] max-w-5xl max-h-[92vh] overflow-y-auto relative">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="sticky top-4 right-4 text-gray-400 hover:text-gray-600 transition z-10 p-2 hover:bg-gray-100 rounded-full"
        >
          <FontAwesomeIcon icon={faTimes} size="xl" />
        </button>

        {/* Header Section with Gradient */}
        <div className="bg-gradient-to-r from-TamnoPlava to-blue-700 px-4 sm:px-6 md:px-8 pt-8 sm:pt-10 md:pt-12 pb-6 sm:pb-8 text-white">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold mb-3 sm:mb-4">
            Posebna Ponuda
          </h2>
          <div className="h-1 w-24 bg-Narandzasta rounded-full mb-4 sm:mb-6"></div>
          <p className="text-lg sm:text-xl md:text-2xl font-semibold text-Narandzasta leading-relaxed max-w-2xl">
            🎁 Popust do 100km
          </p>
        </div>

        {/* Content Section */}
        <div className="px-4 sm:px-6 md:px-8 py-6 sm:py-8 md:py-10">
          {/* Subtitle */}
          <div className="bg-orange-50 border-l-4 border-Narandzasta rounded-r-lg p-4 sm:p-5 md:p-6 mb-6 sm:mb-8">
            <p className="text-sm sm:text-base md:text-lg lg:text-xl font-semibold text-TamnoPlava leading-relaxed">
              Popunite formu ispod i osigurajte se da dobijete <span className="text-Narandzasta font-bold">najbolju ponudu</span> za vašu rehabilitaciju
            </p>
          </div>

          {/* Description Text */}
          <p className="text-gray-700 mb-6 sm:mb-8 md:mb-10 text-sm sm:text-base md:text-lg leading-relaxed">
            Kontaktirajte nas kako biste saznali više o našim uslugama i personalizovanom pristupu rehabilitaciji. Naš tim stručnjaka je tu da vam pomogne u vašem putu oporavka.
          </p>

          {/* Zoho Form Iframe */}
          <div className="w-full rounded-xl overflow-hidden shadow-lg mb-6 sm:mb-8">
            <iframe
              aria-label="Kontaktirajte nas"
              frameBorder="0"
              style={{
                height: "450px",
                width: "100%",
                border: "none",
              }}
              src="https://forms.zohopublic.eu/domfamilia1/form/Kontaktformasite/formperma/LY03wwMmy79kbKiri3oMUFkDwco3lBxPrbJNAeH38oE"
              title="Kontakt forma"
              loading="lazy"
            ></iframe>
          </div>

          {/* Close Button at Bottom */}
          <button
            onClick={onClose}
            className="w-full px-4 sm:px-6 md:px-8 py-3 sm:py-4 md:py-5 bg-gradient-to-r from-TamnoPlava to-blue-700 text-white font-bold text-base sm:text-lg rounded-lg hover:from-blue-800 hover:to-blue-900 transition duration-300 shadow-md"
          >
            Zatvori
          </button>
        </div>
      </div>
    </div>
  );
};
